import { useContext } from 'react';
import { GlobalSettingsContext } from '@/providers/globalSettings';
import { type GlobalSettingsContextType } from '@/types/globalSettings.type';

export const useGlobalSettings = (): GlobalSettingsContextType => {
  const context = useContext(GlobalSettingsContext);

  if (!context) {
    throw new Error('useGlobalSettings must be used within an GlobalSettingsProvider');
  }

  return context;
};
